export default __webpack_public_path__ + "static/media/photo8.1b01c5e8.jpg";